import RoutesEnum from 'enums/routes.enum'

export default [
    {
        path: '/agrement/terms',
        name: RoutesEnum.AGREMENT.TERMS,
        view: 'agrement/Terms',
        meta: {
            layout: 'simple',
            title: 'Uslovi Korišćenja | Bookeraj',
            description:
                'Pročitajte naše uslove korišćenja kako biste saznali pravila i uslove koji se odnose na korišćenje naše platforme.',
        },
    },
    {
        path: '/agrement/privacy',
        name: RoutesEnum.AGREMENT.PRIVACY,
        view: 'agrement/Privacy',
        meta: {
            layout: 'simple',
            title: 'Politika Privatnosti | Bookeraj',
            description: 'Pročitajte našu politiku privatnosti kako biste saznali kako tretiramo vaše lične podatke.',
        },
    },
    {
        path: '/agrement/disclaimer',
        name: RoutesEnum.AGREMENT.DISCLAIMER,
        view: 'agrement/Disclaimer',
        meta: {
            layout: 'simple',
            title: 'Odricanje od Odgovornosti | Bookeraj',
            description:
                'Pročitajte naše odricanje od odgovornosti koje objašnjava našu odgovornost i ograničenja vezana za korišćenje naših usluga.',
        },
    },
]
